import AdminLanding from './pages/AdminLanding/AdminLanding';
import MyPolicy from './pages/mypolicy/MyPolicyFrame';
import UserManager from './pages/users/UserManager';
import RIBillingDelivery from './pages/RIBillingDelivery/RIBillingDeliveryComponent';
import ManageRIUsers from './pages/ManageRIUsers/ManageRIUsers';
import RIUserList from './Components/RIUserList/RIUserList';
import RIUserEdit from './Components/RIUserEdit/RIUserEdit';
import MyNotifications from './pages/MyNotifications/MyNotifications';

const adminComponentMap = {
    AdminLanding: { component: 'AdminLanding' },
    MyPolicy: { component: 'MyPolicy' },
    UserManager: { component: 'UserManager' },
    RIBillingDelivery: { component: 'RIBillingDelivery' },
    RIUserList: { component: 'RIUserList' },
    RIUserEdit: { component: 'RIUserEdit' },
    MyNotifications: { component: 'MyNotifications' },
};

const adminComponents = {
    AdminLanding,
    MyPolicy,
    UserManager,
    RIBillingDelivery,
    ManageRIUsers,
    RIUserList,
    RIUserEdit,
    MyNotifications,
};

export {
    AdminLanding,
    MyPolicy,
    UserManager,
    RIBillingDelivery,
    ManageRIUsers,
    RIUserList,
    RIUserEdit,
    adminComponentMap,
    adminComponents,
    MyNotifications
};
